import React from 'react'
import ActiveFilters from '../../../ActiveFilters'
import UbliqueColumn from '../Column'
import UbliqueRow from '../Row'

import './index.scss'

const StripeActiveFilters = ({ filterProps }) => {
  return (
    <UbliqueRow>
      <UbliqueColumn>
        <ActiveFilters filters={filterProps} />
      </UbliqueColumn>
    </UbliqueRow>
  )
}

export default StripeActiveFilters
